// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedQevoSuccess_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="18.75" cy="18.75" r="5.25" fill="#3AD2A3"/>
  <path d="M16.0772 17.631L14.823 18.8852L17.9584 22.021L22.9752 17.0042L21.721 15.75L17.9586 19.5124L16.0772 17.631Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5853 4.17188L13.1327 4.29913C14.9223 4.71514 15.7596 4.7948 17.0699 4.70928L17.2681 4.69634L17.4566 4.75805C19.3571 5.38031 20.6421 6.7138 21.5561 7.9648C22.0142 8.59183 22.3959 9.22197 22.7146 9.75106L22.7166 9.75445C23.0505 10.3089 23.2885 10.7039 23.4992 10.9674L24 11.5937L22.9693 12.8536C21.8024 12.0171 20.377 11.5184 18.836 11.5005C16.4636 10.2965 14.5048 9.71257 13.2791 9.47898L9.90296 11.7806L7.15689 9.478L12.5853 4.17188ZM11.4917 8.05718L10.509 8.98582L12.7974 7.37583L13.1952 7.43527C14.7386 7.66586 17.4014 8.41754 20.5974 10.1608C20.3849 9.82001 20.159 9.47435 19.9102 9.13379C19.145 8.08649 18.2237 7.17373 16.9932 6.71751C15.6936 6.78781 14.7265 6.69657 13.218 6.36972L11.4917 8.05718Z" class="svg-bg"/>
  <path d="M6.93373 11L8.48402 12.2999L0.71728 19.3606L0 18.6534L6.93373 11Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedQevoSuccess is a generated icon component.
 */
let IconMedQevoSuccess = IconMedQevoSuccess_1 = class IconMedQevoSuccess extends IconBaseElement {
    render() {
        return html `${IconMedQevoSuccess_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedQevoSuccess.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedQevoSuccess = IconMedQevoSuccess_1 = __decorate([
    customElement('zui-icon-med-qevo-success')
], IconMedQevoSuccess);
export { IconMedQevoSuccess };
